module.exports = "/packs/images/homepage/facilities/childrens_centres_desktop~1355921625707a36daaf71395ffb9f92.jpg";